import { getQtyUnits } from "@/api/dictionaryAPI";
import { postInquiry, fetchFilteredInquiries, addInquiry, postSupplierInq, postSupplierInqWithoutLogin } from "@/api/inquiryAPI"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const postInquiryQuote = createAsyncThunk("inquiries/postInquiry", async (reqData) => {
  return await postInquiry(reqData);
});

export const getFilteredInquiries = createAsyncThunk("inquiries/getFiltered", async (filters) => {
  return await fetchFilteredInquiries(filters);
});

export const getQtyUnitList = createAsyncThunk("inquiries/unitList", async () => {
  return await getQtyUnits();
});

export const createInquiry = createAsyncThunk(
  "inquiries/createInquiry",
  async (reqData, { rejectWithValue }) => {
    try {
      return await addInquiry(reqData);
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong!");
    }
  }
);

export const contactSupplier = createAsyncThunk("inquiries/contactSupplier", async (reqData) => {
  console.log("ContactSupplier is called........ ");
  console.log("reqData ========== ", reqData)
  if (reqData.f === "continue_buyer") {
    let res = await postSupplierInqWithoutLogin(reqData);
    console.log("Res ........ ", res);
    return res;
  } else {
    return await postSupplierInq(reqData);
  }

});

const InquirySlice = createSlice({
  name: "inquiries",
  initialState: {
    data: null,
    loading: false,
    error: null,
    filtered: [],
    created: null,
    unitList: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postInquiryQuote.pending, (state) => { state.loading = true })
      .addCase(postInquiryQuote.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload
      })
      .addCase(postInquiryQuote.rejected, (state) => {
        state.loading = false;
        state.data = null;
        state.error = "Something Went Wrong!";
      })
      .addCase(getFilteredInquiries.pending, (state) => { state.loading = true })
      .addCase(getFilteredInquiries.fulfilled, (state, action) => {
        state.loading = false;
        state.filtered = action.payload?.data || [];
      })
      .addCase(getFilteredInquiries.rejected, (state) => {
        state.loading = false;
        state.filtered = [];
        state.error = "Failed to load inquiries!";
      })

      .addCase(createInquiry.pending, (state) => {
        state.loading = true;
        state.created = null;
      })
      .addCase(createInquiry.fulfilled, (state, action) => {
        state.loading = false;
        state.created = action.payload;
      })
      .addCase(createInquiry.rejected, (state, action) => {
        state.loading = false;
        state.created = null;
        state.error = action.payload || "Inquiry submission failed!";
      })
      .addCase(contactSupplier.pending, (state) => { state.loading = true })
      .addCase(contactSupplier.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload
      })
      .addCase(contactSupplier.rejected, (state) => {
        state.loading = false;
        state.data = null;
        state.error = "Something Went Wrong!";
      })
      .addCase(getQtyUnitList.pending, (state) => { state.loading = true })
      .addCase(getQtyUnitList.fulfilled, (state, action) => {
        state.loading = false;
        state.unitList = action.payload;
      })
      .addCase(getQtyUnitList.rejected, (state, action) => {
        state.loading = false;
        state.unitList = [];
        state.error = "Something Went Wrong!";
      })
      ;
  }
});

export default InquirySlice.reducer;